var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/security-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "security-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M10.4901 2.23006L5.50015 4.10007C4.35015 4.53007 3.41016 5.89006 3.41016 7.12006V14.5501C3.41016 15.7301 4.19017 17.2801 5.14017 17.9901L9.44016 21.2001C10.8502 22.2601 13.1701 22.2601 14.5801 21.2001L18.8802 17.9901C19.8302 17.2801 20.6101 15.7301 20.6101 14.5501V7.12006C20.6101 5.89006 19.6701 4.53007 18.5201 4.10007L13.5302 2.23006C12.6802 1.92006 11.3201 1.92006 10.4901 2.23006Z",
    fill: "#00ADEF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9003 11.3C11.9203 11.3 11.9403 11.3 11.9603 11.3H11.9803H12.0003C13.1503 11.26 14.0503 10.33 14.0603 9.17003C14.0603 7.99003 13.1003 7.03003 11.9203 7.03003C10.7403 7.03003 9.78027 7.99003 9.78027 9.17003C9.80027 10.32 10.7003 11.26 11.9003 11.3Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.1902 13.4101C12.9802 12.6101 11.0201 12.6101 9.80014 13.4101C9.24014 13.7901 8.91016 14.3301 8.91016 14.8901C8.91016 15.4601 9.23014 15.9801 9.80014 16.3601C10.4101 16.7601 11.2001 16.9701 11.9901 16.9701C12.7801 16.9701 13.5801 16.7701 14.1801 16.3601C14.7401 15.9801 15.0702 15.4401 15.0702 14.8801C15.0802 14.3101 14.7602 13.7901 14.1902 13.4101Z",
    fill: "#00ADEF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityUser);
export default __webpack_public_path__ + "static/media/security-user.ce922bc195cb4458bf0b0883d77a5c81.svg";
export { ForwardRef as ReactComponent };